import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiTab from '@material-ui/core/Tab';
import { combineProps, styled, useThemeProps, } from '../../../foundation';
import { TabStyle } from './styles';
import { RcTabClasses } from './utils';
var _RcTab = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTab' });
    var classesProp = props.classes, children = props.children, direction = props.direction, rest = __rest(props, ["classes", "children", "direction"]);
    var classes = useMemo(function () { return combineProps(RcTabClasses, classesProp); }, [classesProp]);
    return React.createElement(MuiTab, __assign({}, rest, { ref: ref, classes: classes }));
});
var RcTab = styled(_RcTab)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TabStyle);
RcTab.defaultProps = {
    size: 'small',
};
RcTab.displayName = 'RcTab';
export { RcTab };
var templateObject_1;
